export const CareerLevelEnum = Object.freeze({
  Intern: 0,
  EntryLevel: 1,
  Intermediate: 2,
  Senior: 3,
  Manager: 4,
  Director: 5,
  Other: 6,
});

export const CareerLevelLabel = Object.freeze({
  [CareerLevelEnum.Intern]: "Intern",
  [CareerLevelEnum.EntryLevel]: "Entry Level",
  [CareerLevelEnum.Intermediate]: "Intermediate",
  [CareerLevelEnum.Senior]: "Senior",
  [CareerLevelEnum.Manager]: "Manager",
  [CareerLevelEnum.Director]: "Director",
  [CareerLevelEnum.Other]: "Other",
});

// Helper to get list
export const getCareerLevelList = () =>
  Object.values(CareerLevelEnum).map((value) => ({
    value,
    label: CareerLevelLabel[value],
  }));
